import { bridgeKeys } from "./keys";
import type { ObjectValues } from "@becon-team/becon-fe-lib/my-types";

const userAgent = {
  android: "android",
  ios: "ios",
  web: "web",
} as const;

const { android, ios, web } = userAgent;

export const platform: ObjectValues<typeof userAgent> = navigator.userAgent.includes(bridgeKeys.becon_ios)
  ? ios
  : navigator.userAgent.includes(bridgeKeys.becon_android)
  ? android
  : web;
